import React, { createContext, useContext, useEffect, useState } from "react";
import {
  createStatusClient,
  statusUrl,
  statusView,
} from "../../lib/status/client";

const initial = { data: null, fetchedAt: 0, error: null };
const StatusContext = createContext({
  ...initial,
  ...statusView(initial),
  loading: true,
});

export function WebsiteStatusProvider({ children }) {
  const [state, setState] = useState({
    ...initial,
    ...statusView(initial),
    loading: true,
  });
  useEffect(() => {
    let storage;
    try {
      storage = window.sessionStorage;
    } catch {
      /* Storage is optional. */
    }
    const fixtureUrl = process.env.GATSBY_STATUS_FIXTURE_URL;
    const local = ["localhost", "127.0.0.1", "::1", "[::1]"].includes(
      window.location.hostname,
    );
    // Test endpoints are never queried from a deployed public website.
    const url =
      fixtureUrl && local
        ? fixtureUrl
        : statusUrl({
            projectId:
              process.env.GATSBY_STATUS_SANITY_PROJECT_ID || "np7zertu",
            dataset: process.env.GATSBY_STATUS_SANITY_DATASET || "production",
          });
    const client = createStatusClient({ url, storage });
    let active = true;
    const publish = (snapshot) => {
      if (active)
        setState({
          ...snapshot,
          ...statusView(snapshot),
          loading: !snapshot.data && !snapshot.error,
        });
    };
    publish(client.getSnapshot());
    const refresh = async () => {
      if (document.visibilityState === "hidden") return;
      publish(client.getSnapshot());
      publish(await client.refresh());
    };
    refresh();
    const timer = window.setInterval(refresh, 5_000);
    document.addEventListener("visibilitychange", refresh);
    window.addEventListener("focus", refresh);
    window.addEventListener("online", refresh);
    return () => {
      active = false;
      window.clearInterval(timer);
      document.removeEventListener("visibilitychange", refresh);
      window.removeEventListener("focus", refresh);
      window.removeEventListener("online", refresh);
    };
  }, []);
  return (
    <StatusContext.Provider value={state}>{children}</StatusContext.Provider>
  );
}

export const useWebsiteStatus = () => useContext(StatusContext);
